import styled from 'styled-components'

export const HelpTextWrapper = styled.div`
  line-height: 12px;

  > label {
    font-size: 12px;
  }
`
